export default "__VITE_ASSET__CCaBhPOl__"